import { useNavigate } from "react-router-dom";

// Persistent floating pill in the top-right that flips between the immersive
// horizontal Hall walkthrough and the catalogue Grid view.
export default function ViewToggle({ current }) {
  const navigate = useNavigate();
  const go = (to) => {
    if (to === current) return;
    navigate(to === "hall" ? "/" : "/paintings");
  };

  return (
    <div className="view-toggle" role="tablist" aria-label="Change gallery view" data-testid="view-toggle">
      <button
        type="button"
        role="tab"
        aria-selected={current === "hall"}
        className={`view-toggle__btn ${current === "hall" ? "is-active" : ""}`}
        onClick={() => go("hall")}
        data-testid="view-toggle-hall"
      >
        <span className="view-toggle__ico" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
        Hall
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={current === "grid"}
        className={`view-toggle__btn ${current === "grid" ? "is-active" : ""}`}
        onClick={() => go("grid")}
        data-testid="view-toggle-grid"
      >
        <span className="view-toggle__ico view-toggle__ico--grid" aria-hidden="true">
          <span /><span /><span /><span />
        </span>
        Grid
      </button>
    </div>
  );
}
